import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-convert-term-insurance-to-permanent-insurance'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Convert Term Insurance To Permanent Insurance
        </Typography>
        <Typography nextElement='typography'>
          Visit the <Link linkUrl="/life-insurance/term-life-insurance/convertible-term-life-insurance/" variant='primaryDeemphasize'>
            Term Conversion Center</Link> to learn why you would want to
          convert your term insurance to a permanent insurance policy and what your conversion rights are,
          including the conversion period and conversion credits.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
